export function isTreeOwner(tree: any, currentUser: any): boolean {
  if (!currentUser || !tree) return false;
  return currentUser.uid === tree.created_by;
}
